<template>
  <v-container fluid class="background vh-100">
    <v-row justify="center">
      <v-col cols="12" md="8">
        <v-row justify="center" class>
          <v-img :src="imageLogoUrlBlue" max-height="200px" contain aspect-ratio="1.7"></v-img>
        </v-row>
        <v-card color="background" elevation="0" flat v-if="!showLinkExpiryCard.status">
          <v-card-title primary-title class="py-0 pb-7 pt-0">
            <v-row justify="center">
              <span class="text-h5 font-weight-light primary--text">RESET PASSWORD</span>
            </v-row>
          </v-card-title>
          <v-card-text class="py-0">
            <v-form @submit.prevent ref="reset-password-form">
              <v-row justify="center">
                <v-col cols="12" md="8">
                  <v-text-field
                    autocomplete
                    :rules="[required('Password'),strongPassword() ]"
                    v-model="password"
                    flat
                    solo
                    label="password"
                    :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                    :type="showPassword ? 'text' : 'password'"
                    @click:append="showPassword = !showPassword"
                  ></v-text-field>
                  <v-text-field
                    autocomplete
                    :rules="[required('Confirm password'),confirmPassword(password,confirm_password)]"
                    v-model="confirm_password"
                    flat
                    solo
                    label="confirm password"
                    :append-icon="showConfirmPassword ? 'mdi-eye-off' : 'mdi-eye'"
                    :type="showConfirmPassword ? 'text' : 'password'"
                    @click:append="showConfirmPassword = !showConfirmPassword"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="pt-3">
            <v-row justify="center">
              <v-col cols="12" class="ma-0 pa-0 text-center">
                <v-btn
                  @click="setNewPassword"
                  class="py-6 px-11"
                  large
                  color="primary"
                >Change Password</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
        <v-card v-else>
          <v-row justify="start">
            <v-btn @click="$router.push('/login')" color="primary" class="text-capitalize" text>
              <v-icon>mdi-chevron-left</v-icon>{{$t('login')}}
            </v-btn>
          </v-row>
          <v-card-title primary-title class="py-0 py-7 pt-2">
            <v-row justify="center">
              <span class="text-h5 font-weight-light primary--text">Link Expired</span>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row justify="center">
              <p>This link is no longer valid. Please request to reset the password again. If problem persists, contact support.</p>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-layout align-center justify-center></v-layout>
  </v-container>
</template>

<script>
import { CONSUMERS_API } from '@/clients/consumers.api'
import { required, strongPassword, confirmPassword } from '@/utils/validations'
export default {
  created () {
    if (this.$route.query.token) {
      this.verifyResetToken(this.$route.query.token)
    } else {
      this.showLinkExpiryCard.status = true
    }
  },
  data () {
    return {
      showPassword: false,
      showConfirmPassword: false,
      password: '',
      confirm_password: '',
      showLinkExpiryCard: {
        status: false,
        message: ''
      }
    }
  },
  methods: {
    required,
    strongPassword,
    confirmPassword,
    async verifyResetToken (token) {
      let res
      try {
        res = await CONSUMERS_API.Auth.verifyResetToken(token)
      } catch (error) {
        this.showLinkExpiryCard.status = true
        return console.log(error)
      }
      console.log(res)
    },
    async setNewPassword () {
      if (!this.$refs['reset-password-form'].validate()) {
        return true
      }
      this.$spinner()
      // verify reset token
      let res
      try {
        res = await CONSUMERS_API.Auth.verifyResetToken(this.$route.query.token)
      } catch (error) {
        this.showLinkExpiryCard.status = true
        this.$spinner()
        return console.log(error)
      }
      // change password
      let res2
      try {
        res2 = await CONSUMERS_API.Auth.setNewPassword(this.$route.query.token, { password: this.password, confirm_password: this.confirm_password })
      } catch (error) {
        this.$spinner()
        return console.log(error)
      }
      this.$snackbar({ text: 'Your password was updated successfully. You can now log in.', icon: 'mdi-check-circle', color: 'success', timeout: 7000 })
      this.$spinner()
      return this.$router.push('/login')
    }
  },
  computed: {
  }
}
</script>

<style lang="scss" scoped>
.bg-image {
  background: rgba($color: #f0f0f0, $alpha: 1);
}
.transparent-card {
  background: rgba(255, 255, 255, 0);
}

.vh-100 {
  min-height: 100vh;
}
a {
  text-decoration: underline;
}
</style>
